import { z } from 'zod';
import { LabelTemplateSchema, PrinterDriverSchema } from '../domain/label.js';

export const PrinterDeviceSchema = z.object({
  id: z.string(),
  name: z.string(),
  driver: PrinterDriverSchema,
  // T-081 follow-up: aggiunto 'ble' per Bluetooth Low Energy.
  // - 'bluetooth' = BT Classic SPP (Clabel CT221B, Xprinter, HPRT, ecc.)
  // - 'ble'       = Bluetooth Low Energy (Niimbot, Phomemo, BLE-only)
  // Stampanti pre-T-081 hanno connection='bluetooth' (default legacy).
  connection: z.enum(['bluetooth', 'ble', 'wifi', 'usb']),
  address: z.string(),
  model_hint: z.string().nullable().optional(),
  dpi: z.union([z.literal(203), z.literal(300)]).optional(),
});
export type PrinterDevice = z.infer<typeof PrinterDeviceSchema>;

export const PrinterStatusSchema = z.object({
  online: z.boolean(),
  paper_ok: z.boolean(),
  cover_closed: z.boolean(),
  battery_pct: z.number().nullable().optional(),
  error_code: z.string().nullable().optional(),
});
export type PrinterStatus = z.infer<typeof PrinterStatusSchema>;

export interface PrinterSession {
  readonly deviceId: string;
  readonly dpi?: number;
  readonly model_hint?: string;
  readonly driver: z.infer<typeof PrinterDriverSchema>;
  // T-081 follow-up: ricordo del transport per scegliere classic vs BLE
  // su write/disconnect successivi senza doverlo dedurre da capacitor.
  readonly connection?: 'bluetooth' | 'ble' | 'wifi' | 'usb';
}

export interface PrinterAdapter {
  readonly driver: z.infer<typeof PrinterDriverSchema>;
  discover(): Promise<PrinterDevice[]>;
  connect(device: PrinterDevice): Promise<PrinterSession>;
  disconnect(session: PrinterSession): Promise<void>;
  printLabel(
    session: PrinterSession,
    template: z.infer<typeof LabelTemplateSchema>,
    data: Record<string, unknown>,
    copies?: number,
  ): Promise<void>;
  getStatus(session: PrinterSession): Promise<PrinterStatus>;
}
